import React from 'react';
import {IconMessageSquare,IconArrowUp,IconUsers,IconStar,IconCalendar,IconDollarSign} from './Icons';
import {SIGNIN_URL} from '../siteConfig';

const channels=[
  {text: 'Text messages',tone: 'p-lav'},
  {text: 'Missed calls',tone: 'p-blue'},
  {text: 'Website chat',tone: 'p-peach'},
  {text: 'Facebook & Google',tone: 'p-green'}
];

const glance=[
  {icon: IconUsers,title: '12 new leads',sub: 'Last 7 days'},
  {icon: IconCalendar,title: '5 upcoming',sub: 'Bookings'},
  {icon: IconStar,title: '4.9 rating',sub: 'From your reviews'},
  {icon: IconDollarSign,title: '$1,240',sub: 'Paid this week'}
];

function AppPreview() {
  return (
    <section className="section assistant-section" id="your-app">
      <div className="center-heading">
        <span className="kicker">Your own app</span>
        <h2>Everything in one place.<br /><em>On your computer or phone.</em></h2>
        <p className="assistant-intro">
          Every text, call, chat and email lands in one inbox. Your contacts, bookings, reviews and payments sit right next to it. Sign in anytime to see what is happening, or let us keep an eye on it for you.
        </p>
      </div>
      <div className="portal reveal">
        <div className="portal-chat">
          <span className="chat-icon"><IconMessageSquare /></span>
          <h3>One inbox for every customer.</h3>
          <p>Reply to anyone from one screen, whether they texted, called, chatted on your website or messaged you on Facebook or Google.</p>
          <div className="prompt-grid">
            {channels.map((c)=> <span className={`prompt ${c.tone}`} key={c.text}>{c.text}</span>)}
          </div>
          <div className="chat-input"><span>Reply to Maria: “Yes, we can come out Thursday…”</span><i><IconArrowUp /></i></div>
        </div>
        <aside className="portal-side">
          <b>At a glance</b>
          {glance.map(({icon: Icon,title,sub})=> (
            <div className="glance" key={title}>
              <span className="glance-icon"><Icon /></span>
              <div><strong>{title}</strong><small>{sub}</small></div>
            </div>
          ))}
        </aside>
      </div>
      <p className="service-note">
        Already a client? <a className="footer-link" href={SIGNIN_URL}>Sign in to your app</a>
      </p>
    </section>
  );
}

export default AppPreview;
